import LoginPicture from "./login_picture2.jpg";
import ILForbidden from './forbidden.png';
import ILError404 from './error-404.png';
import ICSuccess from './ic_success.png';

export { LoginPicture, ILForbidden, ILError404, ICSuccess };
